import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

export const visibleKeys: TRevenueSnapshotKeys[] = [
  'PersonalSystemsByMarketsTotal',
  'PolyByMarketsTotal',
  'PrintByMarketsTotal',
  'Revenue3D',
]

export const keyField = 'Key'
